/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    import IReports = DealerwareWebComponents.IReportsConfiguration
    import Languages = DealerwareWebComponents.Languages

    // Eh, let's try to collapse these two constants into one now that we kinda know what the bleep
    // we're doing here.  The Royal we I mean.
    //
    getDealerwareWebComponentsModule()
        .constant(
        'apiToGridMapVehiclesInventory', {
            'year'                      : 'model_year',
            'fuel'                      : 'fuel_level',
            'last_contract_date'        : 'contract_finished_at'
        }
    );

    export class ReportsInventoryDirectiveController {

        public static $inject : string[ ] = [
            '$scope',
            '$q',
            '$filter',
            '$state',
            'apiToGridMapVehiclesInventory',
            'DealerwareVehicleCollection',
            '$dealerwareNotification',
            '$controller',
            'uiGridConstants',
            '$mobilityCompanyAuthentication',
            'ConvertUnits',
            '$dealerwareInternationalizationData'
        ];

        private reports                 : any = { };
        private gridColumns             : any;
        private defaultGridSorts        : any = {
            sort_by         : 'last_contract_date',
            sort_direction  : 'desc'
        };

        private configuration           : IReports;

        private exportDataLoadedDefer   : ng.IDeferred<any> = this.$q.defer();
        private isMetric: boolean;

        public labels: {};

        constructor(
            private $scope: ng.IScope,
            private $q: ng.IQService,
            private $filter: any,
            private $state: any,
            private apiToGridMapVehiclesInventory: any,
            private DealerwareVehicleCollection: any,
            private $dealerwareNotification: any,
            private $controller: any,
            private uiGridConstants: any,
            private $mobilityCompanyAuthenticationProvider : any,
            private ConvertUnits : any,
            public $dealerwareInternationalizationData: any
        ) {
            this.getLabels('inventory');
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                    _self.labels.report.columnHeaders = _self.$dealerwareInternationalizationData.formatLabelsByLanguage(localStorage.getItem('language'), _self.labels.report.columnHeaders);
                    _self.initColumns();
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public initColumns() : void {
            const _self = this;
            _self.isMetric = _self.$mobilityCompanyAuthenticationProvider.location.settings.metric;
            var filterHeaderHtml = '<div class="report-filter-button-container">'
                + '<md-button class="md-icon-button" style="margin: 0;" aria-label="Refresh" '
                + 'ng-click="col.colDef.showModal(this)">'
                + '<md-icon md-svg-icon="filter" class="icon-filter"></md-icon>'
                + '</md-button>'
                + '</div>';

            var dateTemplate = 'dealerware-inventory-date-filter';

            var numericTemplate = 'dealerware-inventory-numeric-filter';

            var currentYear: number = moment().year(),
                startYear: number = currentYear - 6,
                yearOptions: {}[] = [];

            for (var y = currentYear + 1; y >= startYear + 1; y--) {
                yearOptions.push({ value: y, label: y.toString() });
            }

            this.gridColumns = [
                {
                    name            : 'VIN',
                    displayName     : _self.labels.report.columnHeaders.vin,
                    field           : 'vin',
                    visible         : true,
                    renderHtml      : true,
                    formatCallback  : function () {
                        return _self.reports.dataUtils.isBlank(this.vin) ? '' :
                            '<a class="reports-inventory-table-cell-vin" href="' + _self.$state.href('root.private.application.vehicles.details',
                                { vehicleId: this.car_id }
                            ) + '">' + this.vin + '</a>'
                    },
                    width           : 175
                },

                {
                    name            : 'License Plate',
                    displayName     : _self.labels.report.columnHeaders.license_plate,
                    field           : 'license_plate',
                    visible         : true,
                    renderHtml      : true,
                    formatCallback  : function () {

                        return _self.reports.dataUtils.isBlank(this.license_plate) ? '' :
                            '<a class="reports-inventory-table-cell-license-plate" href="' + _self.$state.href('root.private.application.vehicles.details',
                                { vehicleId: this.car_id }
                            ) + '">' + this.license_plate + '</a>'
                    }
                },

                {
                    name            : 'Model Year',
                    displayName     : _self.labels.report.columnHeaders.model_year,
                    field           : 'model_year',
                    visible         : true,
                    width           : 60,
                    filter          : {
                        type: _self.uiGridConstants.filter.SELECT,
                        selectOptions: yearOptions
                    }
                },

                {
                    name            : 'Make',
                    displayName     : _self.labels.report.columnHeaders.make,
                    field           : 'make',
                    visible         : true,
                    width           : 60
                },

                {
                    name            : 'Model',
                    displayName     : _self.labels.report.columnHeaders.model,
                    field           : 'model',
                    visible         : true,
                    width           : 60,
                    filter          : {
                        type: _self.uiGridConstants.filter.SELECT,
                        selectOptions: [
                            { value: 'A3', label: 'A3' },
                            { value: 'A4', label: 'A4' },
                            { value: 'A6', label: 'A6' },
                            { value: 'A8', label: 'A8' },
                            { value: 'Q3', label: 'Q3' },
                            { value: 'Q5', label: 'Q5' }
                        ]
                    }
                },

                {
                    name            : 'Stock #',
                    displayName     : _self.labels.report.columnHeaders.stock_number,
                    field           : 'stock_number',
                    visible         : true,
                    formatCallback  : function () {
                        return _self.reports.dataUtils.isBlank(this.stock_number)
                            || this.stock_number === 'NULL' ? '' : this.stock_number;
                    }
                },

                {
                    name            : 'Mileage',
                    displayName     : _self.labels.report.columnHeaders.mileage,
                    field           : 'mileage',
                    visible         : true,
                    formatCallback  : function () {
                        const mileageInKm = parseFloat(this.mileage_in_km);
                        const convertedValue = _self.isMetric
                            ? mileageInKm
                            : _self.ConvertUnits.kmToMiles(mileageInKm);

                        return _self.reports.dataUtils.formatDecimalNumberWithGroupSeparators(
                            convertedValue, { decimalPlaces: 0 }
                        );
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {

                        // No data set, as if on page load or filter clear.
                        //
                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'between',
                                startRange  : 1000,
                                endRange    : 12000
                            };
                        }

                        // Save off modal values every time the modal opens so that if values are
                        // changes and Cancel is clicked, values are reset to these.
                        //
                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'mileage';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : filterField,
                            template                : numericTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateNumericFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass           : 'ui-grid-cell-contents-number'
                },

                {
                    displayName     : _self.labels.report.columnHeaders.ccd_mileage,
                    field           : 'ccd_mileage',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.reports.dataUtils.formatDecimalNumberWithGroupSeparators(
                            this.ccd_mileage, { decimalPlaces: 0 }
                        );
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {

                        // No data set, as if on page load or filter clear.
                        //
                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'between',
                                startRange  : 1000,
                                endRange    : 12000
                            };
                        }

                        // Save off modal values every time the modal opens so that if values are
                        // changes and Cancel is clicked, values are reset to these.
                        //
                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'ccd_mileage';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : filterField,
                            template                : numericTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateNumericFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass           : 'ui-grid-cell-contents-number'
                },

                {
                    displayName     : _self.labels.report.columnHeaders.last_ccd_update,
                    field           : 'ccd_updated_at',
                    visible         : false,
                    formatCallback  : function () {
                        return _self.reports.dataUtils.formatDateSimple (this.ccd_updated_at);
                    },
                    useExternalFilter: true,
                    showModal:      function ( columnScope: any ) {

                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'next',
                                times       : 3,
                                interval    : 'months',
                                startDate   : null,
                                endDate     : null,
                                showNextChoice  : true
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'ccd_updated_at';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : filterField,
                            template                : dateTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateDateFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Fuel Level',
                    displayName     : _self.labels.report.columnHeaders.fuel_level,
                    field           : 'fuel_level',
                    visible         : true,
                    exporterFieldCallback: function ( value: any ) {
                        return ' ' + value;
                    },
                    formatCallback  : function () {

                        var fuelFraction = this.fuel_level.toFractionString(16, false);
                        return this.fuel_level > 1 || fuelFraction === '1' ? _self.labels.table.full :
                               this.fuel_level < 0 || fuelFraction === '0' ? _self.labels.table.empty :
                               fuelFraction;
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {

                        // We get the fuel values to this level of precision.
                        //
                        var precision = 6;
                        var round = Math.pow(10, precision);

                        var fuelChoices = [
                            { value: 0,                                 label: 'Empty' },
                            { value: Math.round(1/16  * round) / round, label: '1/16'  },
                            { value: Math.round(1/8   * round) / round, label: '1/8'   },
                            { value: Math.round(3/16  * round) / round, label: '3/16'  },
                            { value: Math.round(1/4   * round) / round, label: '1/4'   },
                            { value: Math.round(5/16  * round) / round, label: '5/16'  },
                            { value: Math.round(3/8   * round) / round, label: '3/8'   },
                            { value: Math.round(7/16  * round) / round, label: '7/16'  },
                            { value: Math.round(1/2   * round) / round, label: '1/2'   },
                            { value: Math.round(9/16  * round) / round, label: '9/16'  },
                            { value: Math.round(5/8   * round) / round, label: '5/8'   },
                            { value: Math.round(11/16 * round) / round, label: '11/16' },
                            { value: Math.round(3/4   * round) / round, label: '3/4'   },
                            { value: Math.round(13/16 * round) / round, label: '13/16' },
                            { value: Math.round(7/8   * round) / round, label: '7/8'   },
                            { value: Math.round(15/16 * round) / round, label: '15/16' },
                            { value: 1,                                 label: 'Full'  }
                        ];

                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type                : 'lteq',
                                startRange          : 1/16,
                                startRangeChoices   : angular.copy(fuelChoices),
                                endRangeChoices     : angular.copy(fuelChoices),
                                showEqChoice        : true,
                                eqDirectionOver     : false
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'fuel';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : 'fuel_level',
                            template                : numericTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateNumericFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Toll Tag #',
                    displayName     : _self.labels.report.columnHeaders.toll_tag,
                    field           : 'toll_tag',
                    visible         : true
                },

                {
                    name            : 'Registration Date',
                    displayName     : _self.labels.report.columnHeaders.registration_date,
                    field           : 'registration',
                    visible         : true,
                    formatCallback  : function () {
                        return _self.reports.dataUtils.formatDateSimple (this.registration);
                    },
                    useExternalFilter: true,
                    showModal:      function ( columnScope: any ) {

                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'last',
                                times       : 3,
                                interval    : 'months',
                                startDate   : null,
                                endDate     : null
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'registration';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : filterField,
                            template                : dateTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateDateFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Registration Expiration Date',
                    displayName     : _self.labels.report.columnHeaders.registration_expiration_date,
                    field           : 'registration_expiration',
                    visible         : true,
                    formatCallback  : function () {
                        return _self.reports.dataUtils.formatDateSimple (this.registration_expiration);
                    },
                    useExternalFilter: true,
                    showModal:      function ( columnScope: any ) {

                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'next',
                                times       : 3,
                                interval    : 'months',
                                startDate   : null,
                                endDate     : null,
                                showNextChoice  : true
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'registration_expiration';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : filterField,
                            template                : dateTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateDateFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Last Contract Date',
                    displayName     : _self.labels.report.columnHeaders.last_contract_date,
                    field           : 'contract_finished_at',
                    visible         : true,
                    formatCallback  : function () {
                        return _self.reports.dataUtils.formatDateSimple (this.last_contract_date);
                    },
                    useExternalFilter: true,
                    showModal:      function ( columnScope: any ) {

                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'last',
                                times       : 7,
                                interval    : 'days',
                                startDate   : null,
                                endDate     : null
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'last_contract_date';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : 'contract_finished_at',
                            template                : dateTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateDateFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Utilization (Last 30)',
                    displayName     : _self.labels.report.columnHeaders.total_utilization,
                    field           : 'total_utilization',
                    visible         : true,
                    formatCallback  : function () {

                        return _self.reports.dataUtils.isBlank(this.total_utilization) ? '0%' :
                            Math.round(this.total_utilization * 100) + '%';
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {

                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'between',
                                startRange  : 0,
                                endRange    : 25,
                                valueTransform: ( rawValue: number ) => {
                                    return rawValue/100;
                                }
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'total_utilization';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : filterField,
                            template                : numericTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateNumericFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass           : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Utilized Days (Last 30)',
                    displayName     : _self.labels.report.columnHeaders.total_utilized,
                    field           : 'utilization_days',
                    visible         : true,
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {

                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'between',
                                startRange  : 0,
                                endRange    : 25
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'utilization_days';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : 'utilization_days',
                            template                : numericTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateNumericFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass           : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Status',
                    displayName     : _self.labels.report.columnHeaders.status,
                    field           : 'current_state',
                    visible         : true,
                    renderHtml      : true,
                    formatCallback  : function () {

                        return _self.reports.dataUtils.isBlank(this.current_state) ? '' :
                            this.current_state === 'rented'              ? 'Rented' :
                            this.current_state === 'returned'            ? 'Returned' :
                            this.current_state === 'staged'              ? 'Staged' :
                            this.current_state === 'in_transit'          ? 'In Transit' :
                            this.current_state === 'in_prep'             ? 'In Prep' :
                            this.current_state === 'maintenance'         ? 'Maintenance' :
                            this.current_state === 'disposed'            ? 'Disposed' :
                            this.current_state === 'hard_hold'           ? 'Hard Hold' :
                            this.current_state === 'in_port_or_transit'  ? 'In Port or Transit' :
                            this.current_state === 'totaled_pending_ins' ? 'Totaled Pending Ins' : '';
                    },
                    filter: {
                        type: _self.uiGridConstants.filter.SELECT,
                        selectOptions: [
                            { value: 'rented',              label: 'Rented' },
                            { value: 'returned',            label: 'Returned' },
                            { value: 'staged',              label: 'Staged' },
                            { value: 'in_transit',          label: 'In Transit' },
                            { value: 'in_prep',             label: 'In Prep' },
                            { value: 'maintenance',         label: 'Maintenance' },
                            { value: 'disposed',            label: 'Disposed' },
                            { value: 'hard_hold',           label: 'Hard Hold' },
                            { value: 'in_port_or_transit',  label: 'In Port or Transit' },
                            { value: 'totaled_pending_ins', label: 'Totaled Pending Ins' }
                        ]
                    }
                },

                {
                    name            : 'Available On Date',
                    displayName     : _self.labels.report.columnHeaders.available_date,
                    field           : 'available_date',
                    visible         : true,
                    formatCallback  : function () {
                        return _self.reports.dataUtils.formatDateSimple (this.available_date);
                    },
                    useExternalFilter: true,
                    showModal:      function ( columnScope: any ) {

                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'last',
                                times       : 14,
                                interval    : 'days',
                                startDate   : null,
                                endDate     : null,
                                showNextChoice  : true
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'available_date';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : filterField,
                            template                : dateTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateDateFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Unvailable On Date',
                    displayName     : _self.labels.report.columnHeaders.unavailable_date,
                    field           : 'unavailable_date',
                    visible         : true,
                    formatCallback  : function () {
                        return _self.reports.dataUtils.formatDateSimple (this.unavailable_date);
                    },
                    useExternalFilter: true,
                    showModal:      function ( columnScope: any ) {

                        // Showing date filter modal for first time: initialize selectors to
                        // plausible default values.
                        //
                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'last',
                                times       : 14,
                                interval    : 'days',
                                startDate   : null,
                                endDate     : null,
                                showNextChoice  : true
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'unavailable_date';

                        _self.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : filterField,
                            template                : dateTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : _self.reports.calculateDateFilter
                        });

                        _self.reports.showFilterModal(filterField);
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Physical Location',
                    displayName     : _self.labels.report.columnHeaders.physical_location,
                    field           : 'physical_location',
                    visible         : true
                },

                {
                    name            : 'Connected Car?',
                    displayName     : _self.labels.report.columnHeaders.connected_car,
                    field           : 'connected',
                    visible         : true,
                    renderHtml      : true,
                    exporterFieldCallback: function ( value: any, unmungedValue: any ) {
                        return unmungedValue.match(/fa\-check/) ? 'Yes' : 'No';
                    },
                    formatCallback  : function () {
                        return this.connected !== false && this.connected !== true ? '' :
                            '<div class="connected-car">' + (
                                this.connected ?
                                    '<i class="fa fa-check"></i>' :
                                    '<i class="fa fa-times"></i>'
                            ) + '</div>';
                    },
                    filter: {
                        type: _self.uiGridConstants.filter.SELECT,
                        selectOptions: [
                            { value: '1', label: 'Yes' },
                            { value: '0', label: 'No' }
                        ]
                    }
                }
            ];

            this.setReportsConfiguration();
        }

        public loadHeadersForExport ( ) : ng.IPromise<any> {

            return this.exportDataLoadedDefer.promise
                .then( ( columns: any[] ) => {
                    return columns.map( ( column: any ) => {
                        return column.name;
                    });
                });
        }

        public getUsDayKey ( dayKey: string ) : string {
            return dayKey.replace(/^(\d{4})\-(\d{2})\-(\d{2})$/, '$2/$3/$1');
        }

        public getExportColumns ( row: any, exportColumns: any[] ) : any[] {

            var _self = this;

            var dayKeyUs: string;

            // Flatten out utilization days into main vehicle object.
            //
            var dateColumns: any[] = [ ];
            Object.keys (row.utilized_days)
                .sort ()
                .forEach ( ( dayKey: string ) => {

                dayKeyUs = _self.getUsDayKey(dayKey);

                // Add a gridColumn for each utilization day.
                //
                dateColumns.push(
                    {
                        name        : dayKeyUs,
                        displayName : dayKeyUs,
                        field       : dayKeyUs,
                        visible     : true
                    }
                )
            });

            // Look ma, no intermediate variables in this scope via IIFE!
            //

            exportColumns.push(...dateColumns);

            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator
            //
            // It's amazing what you can learn through the Google.

            return exportColumns;
        }

        public setExportRows ( rows: any[] ) : void {

            var _self = this;

            // Add utilization day data to the CSV report.
            //
            rows.forEach( ( row: any, i: number ) => {

                // Flatten out utilization days into main vehicle object.
                //
                Object.keys (row.utilized_days)
                    .sort ()
                    .forEach ( ( dayKey: string ) => {
                    rows[i][_self.getUsDayKey(dayKey)] = row.utilized_days[dayKey];
                });
            });
        }

        public loadThisPageDataForExport ( ) : ng.IPromise<any> {
            return this.loadPageDataForExport ('loadThisPageDataForExport');
        }

        public loadAllDataForExport ( ) : ng.IPromise<any> {
            return this.loadPageDataForExport ('loadAllDataForExport');
        }

        public loadPageDataForExport ( loadMethod: string ) : ng.IPromise<any> {

            var _self = this;

            var defer = this.$q.defer();

            this.reports[loadMethod] ()
                .then ( ( rows: any ) => {

                if (rows.length) {

                    var exportColumns = _self.getExportColumns (rows[0], angular.copy(_self.reports.gridColumnDefs));
                    _self.setExportRows (rows);

                    // Send in the cars.
                    //
                    defer.resolve ( { rows: rows, columns: exportColumns } );

                    // Getting all the data was necessary in order to know what the CSV column headers
                    // text is, so resolve that promise too so that ng-csv's header method obtains
                    // said headers.
                    //
                    this.exportDataLoadedDefer.resolve (exportColumns);
                }
                else {
                    defer.resolve( [ ] );
                }
            });

            return defer.promise;
        }

        public setReportsConfiguration () : void {

            var _self = this;

            // This report's configuration.
            //
            this.configuration = {
                grid        : {
                    defaultSorts    : this.defaultGridSorts,
                    defaultFilters  : {},
                    columnMap       : this.apiToGridMapVehiclesInventory,
                    columns         : this.gridColumns
                },
                collection  : {
                    model                   : this.DealerwareVehicleCollection,
                    loadMethod              : 'inventory',
                },
                $scope              : this.$scope
            };


            // Add base controller members to this report.
            //
            this.reports = this.$controller('ReportsController', {
                thisReportConfiguration : this.configuration,
                '$scope'                : this.$scope
            });

            // CSV config uses bases ReportsController methods for dataLoading,
            // but they could be custom for this report.
            //
            var exportFileName = 'vehicle_inventory_' + moment().format('YYYY_MM_DD') + '.csv';
            this.configuration.csvExport = {
                showExporterMenu: false,
                thisPage    : {
                    fileName            : exportFileName,

                    dataLoadMethod  : ( ) => {

                        // Switch scope of load method to this controller's.
                        //
                        return this.loadThisPageDataForExport.call (_self);
                    },

                    headersLoadMethod  : ( ) => {

                        // Switch scope of load method to this controller's.
                        //
                        return this.loadHeadersForExport.call (_self);
                    }
                },
                allPages    : {
                    fileName        : exportFileName,

                    dataLoadMethod  : ( ) => {
                        return this.loadAllDataForExport.call (_self);
                    },

                    headersLoadMethod  : ( ) => {
                        return this.loadHeadersForExport.call (_self);
                    },

                    sort: {
                        by         : 'last_contract_date',
                        direction  : 'desc'
                    }
                }
            };

            // update the export filename to add location name after the location has loaded
            this.$scope.$watch(() => {
                return this.reports.locationName;
            }, (locationName: string) => {
                if (locationName) {
                    var exportFileName = this.$filter('spaceless')(locationName.toLowerCase()) + '_vehicle_inventory_' + moment().format('YYYY_MM_DD') + '.csv';

                    this.configuration.csvExport.thisPage.fileName = exportFileName;
                    this.configuration.csvExport.allPages.fileName = exportFileName;
                }
            });
        }
    }

    getDealerwareWebComponentsModule().controller(
        'ReportsInventoryDirectiveController',
        ReportsInventoryDirectiveController
    );


    export class ReportsInventoryDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ReportsInventoryDirectiveController';
        public controllerAs     : string    =   'vm';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/reports/inventory/inventory-directive.html';
        public scope            : Object    =   { };
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareReportsInventory',
        ( ) => new ReportsInventoryDirective()
    );
}
